import types from '@/store/types';

export default {
  [types.GET_USERS]({
    state,
    commit,
    getters,
  }) {
    return getters.usersCollection
      .get().then((querySnapshot) => {
        const results = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          if (data.modifiedAt) {
            data.modifiedAt = data.modifiedAt.seconds * 1000;
          }
          results.push({
            id: doc.id,
            ...data,
          });
        });
        state.has_users_loaded = true;
        state.users_list = results;
        return results;
      })
      .catch((error) => {
        commit(types.SHOW_SNACKBAR, {
          color: 'error',
          message: error.message,
        }, {
          root: true,
        });
        throw error;
      });
  },
  [types.CREATE_USER]({
    rootState,
    getters,
    commit,
  }, payload) {
    const modifiedPayload = {
      ...payload,
      ...getters.commonUserData(payload),
    };
    return getters.usersCollection.add(modifiedPayload).then((res) => {
      commit(types.SHOW_SNACKBAR, {
        message: rootState.messages.SAVE_USER_SUCCESS,
      }, {
        root: true,
      });
      return res;
    }).catch((error) => {
      commit(types.SHOW_SNACKBAR, {
        color: 'error',
        message: error.message,
      }, {
        root: true,
      });
      throw error;
    });
  },
  [types.UPDATE_USER]({
    rootState,
    getters,
    commit,
  }, payload) {
    const modifiedPayload = {
      ...payload,
      ...getters.commonUserData(payload),
    };
    return getters.usersCollection.doc(payload.id)
      .set(modifiedPayload, {
        merge: true,
      }).then((res) => {
        commit(types.SHOW_SNACKBAR, {
          message: rootState.messages.SAVE_USER_SUCCESS,
        }, {
          root: true,
        });
        return res;
      }).catch((error) => {
        commit(types.SHOW_SNACKBAR, {
          color: 'error',
          message: error.message,
        }, {
          root: true,
        });
        throw error;
      });
  },
  [types.DELETE_USER]({
    rootState,
    getters,
    commit,
  }, payload) {
    return getters.usersCollection.doc(payload)
      .delete().then((res) => {
        commit(types.SHOW_SNACKBAR, {
          message: rootState.messages.REMOVE_USER_SUCCESS,
        }, {
          root: true,
        });
        return res;
      }).catch((error) => {
        commit(types.SHOW_SNACKBAR, {
          color: 'error',
          message: error.message,
        }, {
          root: true,
        });
        throw error;
      });
  },
  [types.DELETE_ALL_USERS]({
    rootState,
    getters,
    commit,
  }, payload) {
    const allResuests = [];
    payload.forEach((item) => {
      allResuests.push(getters.usersCollection.doc(item.id).delete());
    });
    return Promise.all(allResuests).then((results) => {
      commit(types.SHOW_SNACKBAR, {
        message: rootState.messages.REMOVE_ALL_USERS_SUCCESS,
      }, {
        root: true,
      });
      return results;
    }).catch((error) => {
      commit(types.SHOW_SNACKBAR, {
        color: 'error',
        message: error.message,
      }, {
        root: true,
      });
      throw error;
    });
  },
};
